import gql from 'graphql-tag';

export const GET_MODULES = gql`
  query getModules {
    self {
      id
      positionStatus
    }
    labModules(sort: "priority") {
      id
      name
      shortDescription
      coverImage {
        url
      }
      labCourses {
        name
        labLessons {
          id
        }
      }
    }
  }
`;
